import queryClient from '@/Config/api/queryClient';
import { QueryKey } from '@/Config/api/queryKey';
import { getScenarioId } from '@/Config/auth/authStore';

interface BootstrapShape {
  config?: {
    api_key?: string;
    human_handoff_active?: boolean;
    preview_identity_token?: string | null;
  };
}

function readBootstrap(): BootstrapShape | undefined {
  return queryClient.getQueryData<BootstrapShape>([QueryKey.app.bootstrap, getScenarioId()]);
}

export const CHAT_PAGE_ACCESS_TOKEN_KEY = 'chat_page_access_token';

/**
 * Scenario id resolved from the URL at module-load time. Prefer
 * `getCurrentScenarioId()` in SPA contexts where users navigate between bots.
 */
export const SCENARIO_ID: string = getScenarioId() || '';

/**
 * Returns the current scenario_id, sourced from the URL (SPA-aware) and
 * re-evaluated on every call.
 */
export function getCurrentScenarioId(): string {
  return getScenarioId() || '';
}

/**
 * Human-handoff feature flag from the bootstrap response. Call during render —
 * the returned value reflects the latest bootstrap cache entry.
 */
export function isHumanHandoffActive(): boolean {
  return readBootstrap()?.config?.human_handoff_active ?? false;
}

/**
 * Preview-identity token from the bootstrap response.
 */
export function getPreviewIdentityToken(): string | null {
  return readBootstrap()?.config?.preview_identity_token ?? null;
}

export function getApiKey(): string {
  return readBootstrap()?.config?.api_key ?? '';
}
